import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  Badge,
} from "reactstrap";
import moment from "moment";
import { IMAGES } from "../../constants";
import { getStatusColor } from "utils";

const EcommerceOrdersModal = (props: any) => {
  const { isOpen, toggle, editDetails: orderDetails } = props;
  // TODO: Display discount and tax for order
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>
        <h5 className="modal-title">Order Details</h5>
      </ModalHeader>
      <ModalBody>
        {orderDetails ? (
          <>
            <div className="mb-4">
              <div className="table-responsive">
                <Table className="table-borderless mb-0">
                  <tbody>
                    <tr>
                      <th scope="row" style={{ width: "200px" }}>
                        Order ID :
                      </th>
                      <td>#{orderDetails.id}</td>
                    </tr>
                    <tr>
                      <th scope="row">Order Date :</th>
                      <td>
                        {moment(orderDetails.order_date).format("DD MMM, YYYY")}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Status :</th>

                      <td>
                        {orderDetails.status && (
                          <Badge
                            className={`font-size-12 badge-soft-${getStatusColor(
                              orderDetails?.status
                            )}`}
                          >
                            <i
                              className="mdi mdi-circle me-1"
                              style={{ fontSize: "10px" }}
                            ></i>
                            {orderDetails?.status.charAt(0).toUpperCase() +
                              orderDetails?.status.slice(1)}
                          </Badge>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Total Amount :</th>
                      <td>
                        GHS {Number(orderDetails.total_amount).toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Payment Method :</th>
                      <td>{orderDetails.payment_method?.name || "N/A"}</td>
                    </tr>
                    <tr>
                      <th scope="row">Branch Name :</th>
                      <td>{orderDetails.branch?.name || "N/A"}</td>
                    </tr>
                    <tr>
                      <th scope="row">Customer ID :</th>
                      <td>{orderDetails.customer?.id || "N/A"}</td>
                    </tr>
                    <tr>
                      <th scope="row">Customer Name :</th>
                      <td>{orderDetails.customer?.name || "N/A"}</td>
                    </tr>
                    <tr>
                      <th scope="row">Organization name :</th>
                      <td>{orderDetails.organization?.name || "N/A"}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>

            {orderDetails.order_items &&
              orderDetails.order_items.length > 0 && (
                <div className="mt-4">
                  <h5 className="mb-3">Order Items</h5>
                  <div className="table-responsive">
                    <Table className="table align-middle table-nowrap">
                      <thead className="table-light">
                        <tr>
                          <th scope="col">Item Name</th>
                          <th scope="col">Quantity</th>
                          <th scope="col">Price</th>
                          <th scope="col" className="text-end">
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {orderDetails.order_items.map(
                          (item: any, index: number) => (
                            <tr key={index}>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={
                                      item.product.image_url ||
                                      IMAGES.DEFAULT_IMAGE
                                    }
                                    alt={item.product.name}
                                    className="rounded me-3"
                                    style={{
                                      width: "48px",
                                      height: "48px",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <h5 className="font-size-14 text-truncate mb-0">
                                    {item.product.name}
                                  </h5>
                                </div>
                              </td>
                              <td>{item.quantity}</td>
                              <td>
                                GHS{" "}
                                {Number(item.unit_price || item.price).toFixed(
                                  2
                                )}
                              </td>
                              <td className="text-end">
                                GHS{" "}
                                {Number(
                                  (item.unit_price || item.price) *
                                    item.quantity
                                ).toFixed(2)}
                              </td>
                            </tr>
                          )
                        )}
                        <tr>
                          <td colSpan={3}>
                            <h6 className="m-0 text-end">Total:</h6>
                          </td>
                          <td className="text-end">
                            <strong>
                              GHS {Number(orderDetails.total_amount).toFixed(2)}
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              )}
          </>
        ) : (
          <div className="text-center">No order details available</div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EcommerceOrdersModal;
